import { LocalDate } from '@js-joda/core';

import { BindingCreator } from '@dreryk/react-common';
import { DatePicker } from '@dreryk/react-components';

import { visitPatientPregnancyStatusTranslationKeys } from '../../translations';

const PREGNANCY_COMPLETION_DATE_FIELD_NAME = 'completionDate';

type PatientPregnancyCompletionDateFormBeanPart = {
   [PREGNANCY_COMPLETION_DATE_FIELD_NAME]: LocalDate | null;
};

type PatientPregnancyCompletionDatePickerProps = {
   readonly register: BindingCreator<PatientPregnancyCompletionDateFormBeanPart>;
};

export const PatientPregnancyCompletionDatePicker = (props: PatientPregnancyCompletionDatePickerProps): JSX.Element => {
   return (
      <DatePicker
         testId={'pregnancyCompletionDate'}
         controller={props.register(PREGNANCY_COMPLETION_DATE_FIELD_NAME)}
         label={visitPatientPregnancyStatusTranslationKeys.pregnancyCompletionDate}
         dayValidators={'dayAfterToday'}
      />
   );
};
